import r from "../../shared-lib/braze-shared-lib.js";
import e from "../managers/braze-instance.js";
import FeatureFlag from "./feature-flag.js";
import ir from "./feature-flags-provider-factory.js";
export function getFeatureFlag(t) {
  if (!e.rr()) return;
  const a = e.ir();
  if (a && !a.ci())
    return r.D.info("Feature flags are not enabled."), new FeatureFlag(t);
  const o = ir.er().pi();
  return o[t] ? o[t] : new FeatureFlag(t);
}
